var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFxfBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.338 2.0951L15.6338 5.15233C15.8451 5.27913 15.9859 5.50455 16 5.75814V10.2383C16 10.4919 15.8592 10.7173 15.6479 10.8441L10.3521 13.9014C10.2394 13.9718 10.1268 14 10 14C9.87324 14 9.76057 13.9577 9.64789 13.9014L0.352113 8.59414C0.129775 8.46904 0.00340909 8.24794 6.79855e-05 7.9985C0.00358827 7.74884 0.143528 7.52752 0.352113 7.40233L9.64789 2.0951C9.85916 1.9683 10.1268 1.9683 10.338 2.0951ZM6.79855e-05 7.9985C2.26843e-05 7.99511 0 7.99173 0 7.98833V8.00814C0 8.00492 2.27099e-05 8.00171 6.79855e-05 7.9985ZM10.2254 4.06346L13.7559 6.10161C13.8967 6.18615 13.9906 6.33642 14 6.50549V9.49228C14 9.66134 13.9061 9.81162 13.7653 9.89615L10.2347 11.9343C10.1596 11.9813 10.0845 12.0001 10 12.0001C9.91549 12.0001 9.84038 11.9719 9.76526 11.9343L6.23474 9.89615C6.08451 9.81162 6 9.66134 6 9.49228V6.50549C6 6.33642 6.0939 6.18615 6.23474 6.10161L9.76526 4.06346C9.90611 3.97892 10.0845 3.97892 10.2254 4.06346Z",
    fill: "url(#paint0_linear_7000_399527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1843 6.77999C12.361 6.99223 12.3321 7.3075 12.1199 7.48416L9.68706 9.50916C9.49065 9.67264 9.20257 9.66171 9.01911 9.48382L7.96443 8.46109C7.76618 8.26885 7.76131 7.95231 7.95355 7.75407C8.14579 7.55582 8.46233 7.55095 8.66057 7.74319L9.39268 8.45311L11.4801 6.71557C11.6924 6.53891 12.0076 6.56775 12.1843 6.77999Z",
    fill: "#667085"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7000_399527",
    x1: 16,
    y1: 8.00002,
    x2: 1.02461e-7,
    y2: 8.00002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475467",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxfBadge);
export default __webpack_public_path__ + "2537e69ca62fcf5589fec8a8c4ee1a7d.svg";
export { ForwardRef as ReactComponent };